var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJournalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83297 0L0 2.83297V27.1965H18.6961L21.5291 24.3635V0H2.83297ZM16.9971 25.4968H1.69888V4.53287H16.9971V25.4968ZM19.8283 23.659L18.6956 24.7922V2.83245H2.40296L3.53595 1.69926H19.8283V23.659Z",
    fill: "#024BD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6028 13.3607L10.428 11.6699L5.958 17.4171L5.58057 20.1463L8.13038 19.1095L12.6028 13.3607Z",
    fill: "#024BD5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0308,
    y: 10.8984,
    width: 1.3035,
    height: 2.7539,
    transform: "rotate(-52.1256 11.0308 10.8984)",
    fill: "#024BD5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalIcon);
export default __webpack_public_path__ + "static/media/journal-icon.e2541ea8.svg";
export { ForwardRef as ReactComponent };